import React from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({
  title,
  subtitle,
  className = '',
  showHr = true
}) => {
  return (
    <>
      {showHr && (
        <div className='row'>
          <div className='col-md-12'>
            <hr />
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-md-12'>
          <span className={className}>{title}</span>
          {subtitle && <span style={{ marginLeft: '10px' }}>{subtitle}</span>}
        </div>
      </div>
      <br />
      <br />
    </>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  showHr: PropTypes.bool
};

export default SectionHeader;